import { TsDOM as q} from '@/scripts/core/TsDOM'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { SlideshowComponent } from '@/scripts/theme/slideshow-component'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video';
import { ProductSlider } from '@/scripts/theme/product-slider'
import { MultiProductSlider } from '@/scripts/theme/multi-product-slider'
import { WaitlistForm } from '@/scripts/theme/waitlist-form'
import { KlaviyoForm } from '@/scripts/theme/klaviyo-form'
import { WelcomePopup } from '@/scripts/theme/welcome-popup'
import '@/scripts/core/cart-attribution'
q.safeDefineElement(UcoastVideo)
q.safeDefineElement(DeferredMedia)
q.safeDefineElement(SliderComponent)
q.safeDefineElement(SlideshowComponent)
q.safeDefineElement(StickyHeader)
q.safeDefineElement(DetailsDisclosure)
q.safeDefineElement(ProductSlider)
q.safeDefineElement(MultiProductSlider)
q.safeDefineElement(KlaviyoForm)
q.safeDefineElement(WelcomePopup)
q.safeDefineElement(WaitlistForm)
